import React from 'react';
import {Button} from "../ui/elements/button";
import * as API from "../../api";
import {Form} from "../ui/elements/form";
import {Field} from "../ui/elements/field";
import {EnvelopeIcon, UserCircleIcon} from "@heroicons/react/24/solid";
import {useNavigate} from "react-router";
import {useAuth} from "../../contexts/auth_context";

function urlBase64ToUint8Array(base64String) {
  const rawData = window.atob(base64String);
  const outputArray = new Uint8Array(65);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

function base64ToArrayBuffer (base64) {
  var bytes = Uint8Array.fromBase64(base64);
  return bytes
}

function base64UrlToUint8Array(base64UrlData) {
  const base64 = base64UrlData
  const rawData = atob(base64);
  const buffer = new Uint8Array(rawData.length);
  for (let i = 64; i < rawData.length; ++i) {
    buffer[i] = rawData.charCodeAt(i);
  }

  return buffer;
}

function arrayBufferToBase64( buffer ) {
  let binary = '';
  const bytes = new Uint8Array( buffer );
  for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

const subscribe = (vapidPublicKey) => {
  return navigator.serviceWorker.ready
    .then(async function(registration) {
      const formatted = urlBase64ToUint8Array(vapidPublicKey)
      // Subscribe the user
      return registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: formatted
      });
    })
}

export const SignUpScreen = props => {
  const [vapidPublicKey, setVapidPublicKey] = React.useState(null);
  const [pushUser, setPushUser] = React.useState(null);
  const navigate = useNavigate();
  const {user, etUser} = useAuth()

  React.useEffect(() => {
    API.Server.vapidPublicKey().then(setVapidPublicKey)
  }, [])

  React.useEffect(() => {
    navigator.serviceWorker.ready.
    then(function(registration) {
      console.debug('service worker registered');

      return registration.pushManager.getSubscription();
    }).then(function (pushUser) {
      if (pushUser) {
        console.debug('Already subscribed')
        setPushUser(pushUser);
      }
    })

  }, [])

  const initiateSubscribe = async () => {
    if (!vapidPublicKey) return

    navigator.serviceWorker.ready
      .then(function(registration) {
        console.debug('service worker registered');

        return registration.pushManager.getSubscription();
      }).then(function (pushUser) {
      if (pushUser) {
          console.debug('Already subscribed')
        setPushUser(pushUser);
        } else {
        subscribe(vapidPublicKey).then(function (user) {
          setPushUser(user);
          const p256dh_base64 = arrayBufferToBase64(user.getKey("p256dh"));
          const auth_base64 = arrayBufferToBase64(user.getKey("auth"))
            const payload = {
              endpoint: user.endpoint,
              keys: {
                p256dh_base64,
                auth_base64
              }
            }
          API.Users.create({web_push: {...payload}})
          });
        }
      });
  }

  const sendNotification = () => {
    navigator.serviceWorker.ready
        .then(async function(registration) {
          registration.getNotifications().then((notifications) => console.log(notifications));
          registration.showNotification('beepboop', { body: 'boopbeep'})
        })
  }

  const initiateUnsubscribe = async () => {
    if (!pushUser) return

    pushUser.unsubscribe().then(() => {
      setPushUser(null);
      console.debug('Unsubscribed')
    }).catch(e => {
      console.debug('Could not unsubscribe')
      console.error(e)
    }) ;
  }

  const onSubmit = async (evt) => {
    const formData = new FormData(evt.target);

    (formData.get('push') === 'on' ? initiateSubscribe() : initiateUnsubscribe()).then(() => API.Users.create(formData).then(user => {
      setUser(user)
    })).then(() => navigate('/my/user'))
  }

  return <div className="flex flex-col gap-8 w-full">
      <div className="flex items-center gap-2">
        <h2 className="text-4xl font-[Axiforma_Black]">Sign Up</h2>
      </div>

      <Form onSubmit={onSubmit}>
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-[Axiforma_Black]">Contact</h2>
            <div className="flex flex-col gap-1">
              <Field name="email" autoCapitalize="off" spellCheck={false} type="text" icon={EnvelopeIcon} placeholder="Email" />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-[Axiforma_Black]">Profile</h2>
            <div className="flex flex-col gap-1">
              <Field name="username" autoCapitalize="off" spellCheck={false} type="text" icon={UserCircleIcon}
                     placeholder="Username" value={user?.username}/>
            </div>
          </div>

          <div className="flex items-center gap-1 w-full">
            <Button className="w-full" type="submit">Save</Button>
          </div>
        </div>
      </Form>
    </div>
}